const mallLevel = {
  type: 'FeatureCollection',
  features: [
    {
      type: 'Feature',
      geometry: {
        type: 'LineString',
        coordinates: [
          [-97.2122618, 49.9186217, 0],
          [-97.2132704, 49.9186217, 0],
          [-97.2132757, 49.9179741, 0],
          [-97.2122457, 49.9179689, 0],
        ],
      },
      properties: {
        name: 'Line 2',
        styleUrl: '#line-92bb3e-11656-nodesc',
        styleHash: '4d294a05',
        styleMapHash: {
          normal: '#line-92bb3e-11656-nodesc-normal',
          highlight: '#line-92bb3e-11656-nodesc-highlight',
        },
        stroke: '#92bb3e',
        'stroke-opacity': 1,
        'stroke-width': 11.656,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'LineString',
        coordinates: [
          [-97.2122424, 49.91889, 0],
          [-97.2122457, 49.9179689, 0],
          [-97.2114378, 49.9179713, 0],
          [-97.2114378, 49.9178555, 0],
        ],
      },
      properties: {
        name: 'Line 3',
        styleUrl: '#line-92bb3e-11656-nodesc',
        styleHash: '4d294a05',
        styleMapHash: {
          normal: '#line-92bb3e-11656-nodesc-normal',
          highlight: '#line-92bb3e-11656-nodesc-highlight',
        },
        stroke: '#92bb3e',
        'stroke-opacity': 1,
        'stroke-width': 11.656,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'LineString',
        coordinates: [
          [-97.2114378, 49.9178555, 0],
          [-97.2104105, 49.917859, 0],
          [-97.2104132, 49.9183167, 0],
          [-97.2111964, 49.9183167, 0],
        ],
      },
      properties: {
        name: 'Line 4',
        styleUrl: '#line-92bb3e-11656-nodesc',
        styleHash: '4d294a05',
        styleMapHash: {
          normal: '#line-92bb3e-11656-nodesc-normal',
          highlight: '#line-92bb3e-11656-nodesc-highlight',
        },
        stroke: '#92bb3e',
        'stroke-opacity': 1,
        'stroke-width': 11.656,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'LineString',
        coordinates: [
          [-97.2114378, 49.9179713, 0],
          [-97.2114405, 49.9180973, 0],
          [-97.2104185, 49.9180991, 0],
        ],
      },
      properties: {
        name: 'Line 5',
        styleUrl: '#line-92bb3e-11656-nodesc',
        styleHash: '4d294a05',
        styleMapHash: {
          normal: '#line-92bb3e-11656-nodesc-normal',
          highlight: '#line-92bb3e-11656-nodesc-highlight',
        },
        stroke: '#92bb3e',
        'stroke-opacity': 1,
        'stroke-width': 11.656,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'LineString',
        coordinates: [
          [-97.2112017, 49.9180991, 0],
          [-97.2112071, 49.9186828, 0],
          [-97.2115933, 49.9186845, 0],
          [-97.2115907, 49.9186206, 0],
          [-97.2122451, 49.9186206, 0],
        ],
      },
      properties: {
        name: 'Line 6',
        styleUrl: '#line-92bb3e-11656-nodesc',
        styleHash: '4d294a05',
        styleMapHash: {
          normal: '#line-92bb3e-11656-nodesc-normal',
          highlight: '#line-92bb3e-11656-nodesc-highlight',
        },
        stroke: '#92bb3e',
        'stroke-opacity': 1,
        'stroke-width': 11.656,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'LineString',
        coordinates: [
          [-97.2117945, 49.9179747, 0],
          [-97.2117918, 49.9186137, 0],
        ],
      },
      properties: {
        name: 'Line 7',
        styleUrl: '#line-92bb3e-11656-nodesc',
        styleHash: '4d294a05',
        styleMapHash: {
          normal: '#line-92bb3e-11656-nodesc-normal',
          highlight: '#line-92bb3e-11656-nodesc-highlight',
        },
        stroke: '#92bb3e',
        'stroke-opacity': 1,
        'stroke-width': 11.656,
      },
    },
    {
      type: 'Feature',
      geometry: {
        type: 'LineString',
        coordinates: [
          [-97.2122451, 49.9182096, 0],
          [-97.2118026, 49.9182096, 0],
        ],
      },
      properties: {
        name: 'Line 8',
        styleUrl: '#line-92bb3e-11656-nodesc',
        styleHash: '4d294a05',
        styleMapHash: {
          normal: '#line-92bb3e-11656-nodesc-normal',
          highlight: '#line-92bb3e-11656-nodesc-highlight',
        },
        stroke: '#92bb3e',
        'stroke-opacity': 1,
        'stroke-width': 11.656,
      },
    },
  ],
};

export default mallLevel;
